var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30956 13.9824C11.4293 13.9824 13.2817 14.4048 14.8667 15.2496C16.4518 16.0944 17.6739 17.2848 18.5333 18.8208C19.4118 20.3376 19.851 22.0944 19.851 24.0912C19.851 26.0688 19.4118 27.8256 18.5333 29.3616C17.6739 30.8976 16.4422 32.088 14.8381 32.9328C13.253 33.7776 11.4102 34.2 9.30956 34.2H1.77588V13.9824H9.30956ZM8.99446 29.9376C10.8468 29.9376 12.2887 29.4288 13.3199 28.4112C14.3511 27.3936 14.8667 25.9536 14.8667 24.0912C14.8667 22.2288 14.3511 20.7792 13.3199 19.7424C12.2887 18.7056 10.8468 18.1872 8.99446 18.1872H6.6742V29.9376H8.99446ZM30.3512 17.928V22.0176H36.911V25.8192H30.3512V30.2544H37.7703V34.2H25.4529V13.9824H37.7703V17.928H30.3512ZM66.5878 13.9824V34.2H61.6895V22.0752L57.1922 34.2H53.2392L48.7132 22.0464V34.2H43.8149V13.9824H49.6012L55.2443 27.9792L60.8302 13.9824H66.5878Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2016 12C58.4975 12 61.1694 9.31371 61.1694 6C61.1694 2.68629 58.4975 0 55.2016 0C51.9057 0 49.2339 2.68629 49.2339 6C49.2339 9.31371 51.9057 12 55.2016 12Z",
    fill: "#F12A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.11159dd53a73ba7b7a5d2329fd447fc3.svg";
export { ForwardRef as ReactComponent };